function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "Category_icon");

var _ref3 =
/*#__PURE__*/
React.createElement("desc", null, "Created with Sketch.");

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "ToDoList_Dashboard",
  transform: "translate(-37.000000, -210.000000)"
}, React.createElement("g", {
  id: "Sidebar"
}, React.createElement("g", {
  id: "Categories",
  transform: "translate(37.000000, 208.000000)"
}, React.createElement("g", {
  id: "Category_icon"
}, React.createElement("path", {
  d: "M13.2688446,14.350225 L5.64835288,13.4294313 C5.30631847,13.385785 5.00079781,13.2290479 4.77013472,12.997681 C4.53947163,12.7663141 4.3836661,12.4603174 4.34106198,12.1181516 L3.44439437,4.91676069 C3.39287336,4.50298088 3.51394724,4.10749056 3.75134632,3.80256494 C3.97930096,3.50977017 4.31450937,3.30047757 4.70715398,3.23867499 L12.4678075,3.95818697 C12.8253495,3.99360344 13.1456477,4.15254878 13.3855978,4.39200716 C13.6255479,4.63146554 13.7851499,4.95143697 13.8212998,5.30890561 L14.5689323,12.7018872 C14.6108859,13.1167462 14.4807129,13.5093357 14.2363367,13.8086988 C14.0018971,14.0958895 13.6623526,14.297281 13.2688446,14.350225 Z",
  id: "Rectangle",
  strokeWidth: 0.98,
  className: "iconFill",
  transform: "translate(9.000182, 8.797785) rotate(-45.000000) translate(-9.000182, -8.797785) "
}), React.createElement("path", {
  d: "M1.44,13.3703704 L8.01667873,18.26776 C8.60021669,18.7022974 9.39978331,18.7022974 9.98332127,18.26776 L16.56,13.3703704 L16.56,13.3703704",
  id: "Path-3",
  strokeWidth: 1.05,
  strokeLinecap: "round",
  className: "iconStroke"
}))))));

var SvgCategoryIcon = function SvgCategoryIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgCategoryIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Category_icon.297445d9.svg";
export { ForwardRef as ReactComponent };